export const endpoints = {
  removeSentinelKey: '/user/sentinel',
  userProfile: '/user/profile',
  setPassword: '/user/set/password',
  addComment: '/comments/add',
  getComment: 'comments/',
  addInsuranceRequests: '/insurance/requests/add',
  removeComment: 'comments/remove',
  updateComment: 'comments/update',
  supportRequest: 'support/request/add',
  getPolicies: 'user/insurance/plans/current',
  getFeatures: 'user/insurance/plans/policies',
  cancelPolicies: 'user/insurance/plans/withdraw',
  claimRaised: 'claim/request/raised',
  reEvaluationRequest: 'claim/request/confirmation',
  getClaimRequest: 'claim/request',
  getPreviousPolicyList: 'user/insurance/plans',
  getResolvedClaimsInPlanHistory: 'user/insurance/plans/claims',
  getThreatChainTransaction: 'threats/user/chain/hash',
  plansPayment: 'user/insurance/plans/payment',
  addClaimManually: 'claim/request/manually',
  addScoreCard: 'domain/security/score/add/request',
  connectRequest: 'admin/connection/request',
  getBlog: 'blog/',
  blogEmojiReaction: 'blog/emoji/reaction',
  signupByQuote: 'user/quote/registration',
  servicesListing: 'user/services/list',
  submitRegReq: 'user/registration/request',
  getPlanForQuote: 'insurance/plans/listing/for/quote',
  getUserQuote: 'user/quote/registration',
  addService: 'user/insurance/plans/add/service',
  activateCoveActivation: 'user/activate/cove',
  getCoveThreatLisiting: 'cove/threats/user/listing',
  getCoveClaimRequest: 'cove/claim/request',
  coveReEvaluationRequest: 'cove/claim/request/confirmation',
  claimRaisedCove: 'cove/claim/request/raised',
  changePolicy: 'user/insurance/plans/change',
  activatePatchService: 'user/activate/patch',
  //patch
  getNSightPatchThreatLisiting: 'patch/threats/user/listing',
  getNSightPatchClaimRequest: 'patch/claim/request',
  NSightPatchReEvaluationRequest: 'patch/claim/request/confirmation',
  claimRaisedNSightPatch: 'patch/claim/request/raised',
  deactivateCove: 'user/deactivate/cove',
  deactivateNSight: 'user/deactivate/patch',
  changePaymentMethod: 'user/add/payment/method',
  addUserRegPayment: 'user/registration/payment',
  //secure score
  activateSecureScore: 'user/activate/secure-score',
  deactivateSecureScore: 'user/deactivate/secure-score',
  getSecureScoreThreatListing: 'secure-score/threats/user/listing',
  getSecureScoreControlStatus: 'secure-score/threats/user/control-status',
  getSecureScoreClaimRequest: 'secure-score/claim/request',
  claimRaisedSecureScore: 'secure-score/claim/request/raised',
  secureScoreReEvaluationRequest: 'secure-score/claim/request/confirmation',
  //mailbox compromise
  getMailboxCompromiseThreatListing: 'mailbox-compromise/threats/user/listing',
  syncMailboxCompromiseThreats: 'mailbox-compromise/threats/user/sync',

  //base on primary Service
  incidentsApplicableCount: 'user/applicable/count',
  merchantAffiliateDetails: 'merchants/affiliate/details',
  MISP_API: '/misp',
  LossRunRation: 'threats/loss',
  BitSightReport: 'user/download/report',
  getCountryList: 'https://valid.layercode.workers.dev/list/countries?format=select&flags=true&value=code',
  planDiscountCalculation: 'user/plan/discount/calculation',

  //microsoft secure score
  activateMicrosoftSecureScore: 'user/activate/secure-score',
  deactivateMicrosoftSecureScore: 'user/deactivate/secure-score',
  getMicrosoftSecureScoreSummary: 'user/secure-score',
  getMicrosoftSecureScoreGraph: 'ai/my-snapshot',

  //windows defender
  activateWindowDefender: 'user/activate/windows-defender',
  deactivateWindowDefender: 'user/deactivate/windows-defender',
  getWindowDefenderThreatLisiting: 'windows-defender/threats/user/listing',
  getWindowDefenderClaimRequest: 'defender/claim/request',
  claimRaisedWindowDefender: 'defender/claim/request/raised',
  windowDefenderReEvaluationRequest: 'defender/claim/request/confirmation',

  //inventory
  getInventory: 'user/devices',
}
